import { motion } from "framer-motion";
import { SiteHeader } from "@/components/SiteHeader";

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-head text-2xl font-bold">{title}</h2>
    <div className="text-[#3A4A63] text-sm leading-relaxed mt-3 space-y-3">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <SiteHeader />

      <motion.main
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl mx-auto px-6 py-16"
      >
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D94833]">Terms &amp; Conditions</p>
        <h1 className="font-head text-4xl sm:text-5xl font-black tracking-tight mt-3">Terms and Conditions</h1>
        <p className="text-[#9CA3AF] text-sm mt-3">Last updated {new Date().getFullYear()}</p>

        <div
          data-testid="terms-disclaimer"
          className="mt-10 border-2 border-[#041C3E] bg-[#F3F4F6] p-6 sm:p-8"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D94833]">Important disclaimer</p>
          <p className="font-head text-lg sm:text-xl font-bold text-[#041C3E] leading-snug mt-3">
            We provide coaching, mentoring, and guidance only. We do not guarantee any form of admission,
            job offer, placement, or intake, and we make no such promises. Our sole aim is to provide guidance
            so you can step up and excel in your chosen role.
          </p>
        </div>

        <Section title="1. Nature of services">
          <p>
            Rhea Sharma, mentor at The Next Move by Rhellex, offers career coaching, mentoring, and strategic guidance for students, junior
            professionals, and international aspirants. Sessions are advisory in nature and are designed to help
            you gain clarity, build a plan, and grow in your chosen role.
          </p>
        </Section>

        <Section title="2. No guarantee of outcomes">
          <p className="font-bold text-[#041C3E]">
            We do not guarantee, promise, or influence admissions, job offers, placements, interview results, or
            any form of intake. Any outcome depends entirely on your own effort, decisions, and circumstances.
          </p>
          <p>
            Nothing on this website, in any session, email, or communication, should be interpreted as a promise
            of a specific result.
          </p>
        </Section>

        <Section title="3. Payments and refunds">
          <p>
            Paid programs are charged in INR. Access to the client intake and assessment unlocks after a
            successful payment. You may cancel and receive a full refund within 24 hours of making the payment.
            Any cancellation made after 24 hours from booking, or less than 36 hours before the scheduled
            session date, will receive only a partial refund.
          </p>
        </Section>

        <Section title="4. Sessions, rescheduling, and cancellations">
          <p>
            Sessions can be rescheduled up to 24 hours before the scheduled start time. For genuine emergencies,
            last minute changes will be accommodated where possible, but rescheduling at least 24 hours ahead is
            strongly preferred so the calendar can be managed. Within 24 hours, please contact Rhea directly.
          </p>
        </Section>

        <Section title="5. Privacy">
          <p>
            Information you share, such as your name, email, phone, and assessment responses, is used only to
            deliver and improve the mentorship you request. We do not sell your information.
          </p>
        </Section>

        <Section title="6. Acceptance">
          <p>
            By using this website and by purchasing or booking a session, you acknowledge that you have read and
            agree to these Terms and Conditions, including the disclaimer above.
          </p>
        </Section>

        <a
          href="/"
          className="inline-block mt-12 border border-[#041C3E] text-[#041C3E] px-8 py-4 font-semibold tracking-wide hover:bg-[#041C3E] hover:text-white transition-colors duration-300"
        >
          Back to home
        </a>
      </motion.main>
    </div>
  );
}
